var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayButton = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 67,
    viewBox: "0 0 95 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.2231 14.4349C93.2231 14.4349 92.3137 7.98199 89.511 5.13734C85.9629 1.40934 81.9824 1.39437 80.1636 1.16979C67.1041 0.226563 47.5149 0.226563 47.5149 0.226563H47.4702C47.4702 0.226563 27.8809 0.226563 14.8214 1.16979C13.0027 1.39437 9.02219 1.40934 5.47406 5.13734C2.67134 7.98199 1.76195 14.4349 1.76195 14.4349C1.76195 14.4349 0.837646 22.0106 0.837646 29.6014V36.713C0.837646 44.2888 1.77686 51.8646 1.77686 51.8646C1.77686 51.8646 2.68625 58.3174 5.48897 61.1621C9.0371 64.8901 13.7033 64.7703 15.7756 65.1596C23.2296 65.8782 47.5 66.1028 47.5 66.1028C47.5 66.1028 67.1041 66.0729 80.1636 65.1296C81.9824 64.9051 85.9629 64.8901 89.511 61.1621C92.3137 58.3174 93.2231 51.8646 93.2231 51.8646C93.2231 51.8646 94.1623 44.2888 94.1623 36.713V29.6014C94.1623 22.0106 93.2231 14.4349 93.2231 14.4349Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8698 18.9863V45.3069L63.0793 32.1915L37.8698 18.9863Z",
    fill: "#EAEAEA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlayButton.3b09b8910362a75b5d930977e6454f0f.svg";